import { render } from "./PrivacyPolicy.vue?vue&type=template&id=7f58f267"
const script = {}
script.render = render

export default script